import { FC } from 'react';
import styles from './contentWrapper.module.scss';

const ContentWrapper: FC = ({children}) => {
  return (<div className={styles.contentWrapper}>
    {children}
  </div>);
};

export default ContentWrapper;